module.exports = __webpack_public_path__ + "img/bmr_boxmazecoins.d181a28.png";